import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "../../services/security.js";
import auth from "../../services/auth.js";
import events from "../../services/events.js";

class SendmessageController {
  constructor(
    $http,
    $state,
    $stateParams,
    $location,
    $interval,
    AuthService,
    EventsService,
    SecurityService,
    $rootScope,
    $localStorage,
    ngProgressFactory,
    $timeout,
    $cookies,
    MessagingService,
    Messagingv2Service,
    $scope,
    $anchorScroll
  ) {
    this.name = "sendmessage";
    this.$http = $http;
    this.$auth = AuthService;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$progress = ngProgressFactory.createInstance();
    this.$events = EventsService;
    this.$localStorage = $localStorage;
    this.$interval = $interval;
    this.$scope = $scope;
    this.$security = SecurityService;
    this.$cookies = $cookies;
    this.$messaging = MessagingService;
    this.$location = $location;
    this.$messagingv2 = Messagingv2Service;
    this.$timeout = $timeout;
    this.$anchor = $anchorScroll;
    this.reqCounter = 0;
    this.$rootScope = $rootScope;
    this.currentUser = this.$auth.getUserData();
    this.disabled = true;
    this.remain_loading_count = 0;
    this.isLazyUser = true;
    this.errorMessage = {status: false, message: null};
    this.newUserObj = {email: null, password: null, password2: null};
    this.showContinueButton = false;
    this.check_policy = false;
    this.displayTOSModal = false;
    this.phone_class = "";

    var _this = this;

    _this.SetJobblerForMessageListener = _this.$rootScope.$on("SetJobblerForMessage", function ($event, params) {
      _this.jobbler = params.jobbler;
      _this.eventId = params.event.id;
      _this.jobblerEmail = params.jobbler.email;
      _this.message = null;
      _this.setHeightOfPage();
      _this.destoryFunc(params.s);
      _this.$messagingv2 = params.m;
    });
  }

  destoryFunc(scp) {
    var _this = this;

    _this.$timeout(function () {
      scp.$on("$destroy", _this.SetJobblerForMessageListener);
    }, 300);
  }
  sendMessageToJobbler() {
    var _this = this;
    var users = _this.constructUsersObject();

    let msg = _this.message;

    _this.createOrReturnChannel(users, msg);
    _this.$timeout(function () {
      jQuery(".applicant-send-message").hide("slow");
    });
    _this.$timeout(function () {
      _this.$rootScope.$broadcast("ShowProfile", {});
    }, 500);
    _this.$timeout(function () {
      _this.$rootScope.$broadcast("ShowNoti", {});
    }, 1000);
  }

  messageChecking() {
    var _this = this;

    if (_this.message.length > 0) {
      _this.disabled = false;
    } else {
      _this.disabled = true;
    }
  }

  constructUsersObject() {
    var _this = this;
    var usersObj = {};
    usersObj.users = _this.currentUser.username + "," + _this.jobblerEmail;
    usersObj.event = _this.eventId;
    return usersObj;
  }

  createOrReturnChannel(users, msg) {
    var _this = this;

    let jobblerArray = [];
    let isNewChannel = true;

    jobblerArray.push(_this.jobbler);
    _this.blockedList = _this.$messagingv2.generateBlockList(jobblerArray);

    let message_data = {
      p1: _this.message,
      p2: null,
      p3: null,
      p4: null,
      p5: _this.blockedList,
      p6: _this.eventId,
      p7: null,
      p8: isNewChannel,
      p9: null,
      p10: null,
      p11: null,
    };

    _this.$messagingv2.createOrReturnChannelTrimmed(users, null, message_data).then(
      function (response) {
        console.log("response");
        console.dir(response.data.result[0].channelName);
        //_this.findChannel(response.data.result[0].channelName);
      },
      function (error) {
        console.log("in error");
      }
    );
  }

  findChannel(channel) {
    var _this = this;

    console.log("looking for channels");
    console.dir(_this.$rootScope.allChannelNames);
  }

  getChannelsReq(channel) {
    var _this = this;
    console.log("getChannelsReq");
    console.dir(channel);
    _this.$timeout(function () {
      _this.$messagingv2.getChannels(1).then(
        function (response) {
          if (response.data.channels.length > 0) {
            if (response.data.channels[0].name === channel) {
              var jobblerArray = [];
              jobblerArray.push(_this.jobbler);
              _this.blockedList = _this.$messagingv2.generateBlockList(jobblerArray);
              var isNewChannel = true;
              var indexOf = null;
              _this.$messagingv2.publishMessage(
                _this.message,
                null,
                null,
                null,
                _this.blockedList,
                _this.eventId,
                response.data.channels[0],
                isNewChannel,
                response.data.channels[0].name,
                indexOf
              );
              var new_chat_with_jobbler = true;
            } else {
              _this.loadChannels(channel);
            }
          } else {
            _this.loadChannels(channel);
          }
        },
        function (error) {
          console.log("in error in send message");
        }
      );
    }, 3000);
  }

  loadChannels(channel) {
    var _this = this;
    _this.getChannelsReq(channel);
  }

  closeAndClearMessageBox() {
    var _this = this;

    _this.$timeout(function () {
      $(".applicant-send-message.hidden-message-box").hide("fast");
    });

    _this.$timeout(function () {
      _this.message = null;
    }, 200);
  }

  setHeightOfPage() {
    var _this = this;

    _this.$timeout(function () {
      $(".applicant-send-message.hidden-message-box").show("slow");
    }, 200);
  }
}

SendmessageController.$inject = [
  "$http",
  "$state",
  "$stateParams",
  "$location",
  "$interval",
  "auth",
  "events",
  "security",
  "$rootScope",
  "$localStorage",
  "ngProgressFactory",
  "$timeout",
  "$cookies",
  "messagingv2",
  "$scope",
  "$anchorScroll",
];

export default SendmessageController;



// WEBPACK FOOTER //
// ./client/app/common/sendmessage/sendmessage.controller.js